/**
 * Created by Daniela on 12/09/2016.
 */
export class Material {
  ativo: boolean; 
  controlaValidade: boolean; 
  dataCriacao: string; 
  dataUltimaAlteracao: string; 
  descricao: string; 
  descricaoCompleta: string; 
  exigeMarca: boolean; 
  inventariavel: boolean; 
  tipo: number; 
  mantemEstoque: boolean; 
  grupoMaterialId: number; 
  contaContabilId: number; 
  medidaId: number; 
  id: number; 
  usuarioCriacaoId: number; 
  usuarioUltimaAlteracaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/shared/material.model.ts
 **/